import { useTranslation } from 'react-i18next';

import { InformationIcon } from '@/lib/icon';
import { Flex } from '@/lib/v2/components/Layout/Stack';

//TO DO: migrate this method to a hook
export const chatShow = () => {
  if (window.$zopim) {
    window.$zopim.livechat.window.show();

    setTimeout(() => {
      const iframeChat = document.getElementById('webWidget') as HTMLObjectElement;

      const closeBtn = Array.from(
        iframeChat?.contentDocument?.getElementsByClassName(
          'sc-htpNat'
        ) as HTMLCollectionOf<HTMLElement>
      )[0];

      closeBtn.addEventListener('click', () => {
        window.$zopim.livechat.button.hide();
      });
    }, 400);
  }
};

export const SupportCard = () => {
  const { t } = useTranslation();

  return (
    <div className="h-modal fixed left-[-78px] z-50 flex items-center justify-start md:h-full">
      <button
        className="card h-6 w-44 -rotate-90 cursor-pointer rounded-lg p-2 shadow"
        onClick={chatShow}
      >
        <Flex withGap alignment="center" gapSize="small">
          <InformationIcon />
          <div className="text-12 font-medium text-sky-700">{t('needHelp')}</div>
        </Flex>
      </button>
    </div>
  );
};
